const openHeaderSearchEl = document.querySelector('[data-open-header-search]')
const headerSearch = document.querySelector('.header-search')

const openHeaderSearch = () => {
    document.body.classList.add('search-open')
    document.querySelector('[data-header-search-field]').focus()
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeHeaderSearch()
    })

    document.addEventListener('click', (event) => {
        if(!event.target.closest('[data-open-header-search]')) {
            closeHeaderSearch()
        }
    })

    headerSearch.addEventListener('click', (event) => event.stopPropagation())
    document.querySelector('.header-search__submit').addEventListener('focusout', (event) => {
        if (event.relatedTarget !== headerSearch.querySelector('.header-search__field')) closeHeaderSearch()
    })
}

const closeHeaderSearch = () => {
    document.body.classList.remove('search-open')
    openHeaderSearchEl.focus()
}

if(openHeaderSearchEl) {
    openHeaderSearchEl.addEventListener('click', openHeaderSearch)
}
